export default __webpack_public_path__ + "static/media/hero.25894a95.svg";